import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../base/Button';

const navItems = [
  { name: 'Home', path: '/' },
  { name: 'Purchase', path: '/purchase' },
  { name: 'About', path: '/about' },
  { name: 'Messages', path: '/messages' },
  { name: 'Contact', path: '/contact' }
];

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ja' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <header className="bg-gray-900 border-b border-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/75eaeb23002452c01ddd137892cf07ae/7775d7eb5d42654a0b94aeae1dc3ce4b.png" 
              alt="DP Crypt" 
              className="h-10 w-auto"
            />
            <span className="text-white text-xl font-bold">DP Crypt</span>
          </Link>

          {/* Language Switcher */}
          <button
            onClick={toggleLanguage}
            className="flex items-center space-x-2 bg-gray-800 hover:bg-gray-700 text-white px-4 py-2 rounded-lg transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-global-line text-lg"></i>
            <span className="font-semibold">{i18n.language === 'en' ? 'EN' : 'JP'}</span>
            <i className="ri-arrow-down-s-line text-sm"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
